import {DatabaseCode, toDatabaseCode} from "./database-code";

export type AllocatableLoadMethod = DatabaseCode;

const perContainer: AllocatableLoadMethod = {
  code: 'PER_CONTAINER',
  displayValue: {
    id: 'common.entity.allocatableloadsettings.method.percontainer',
    defaultMessage: 'Per Container',
  },
};

const perCluster: AllocatableLoadMethod = {
  code: 'PER_COMMINGLED',
  displayValue: {
    id: 'common.entity.allocatableloadsettings.method.perclustger',
    defaultMessage: 'Per Cluster',
  },
};

const perSite: AllocatableLoadMethod = {
  code: 'PER_SITE',
  displayValue: {
    id: 'common.entity.allocatableloadsettings.method.persite',
    defaultMessage: 'Per Site',
  },
};

export const allocatableLoadMethod = {
  perContainer,
  perCluster,
  perSite,
};

export const allocatableLoadMethods = Object.values(allocatableLoadMethod);

export const toAllocatableLoadMethod = (code: string): AllocatableLoadMethod =>
  toDatabaseCode(code, allocatableLoadMethods);

export const toAllocatableLoadMethodSafely = (code: string | undefined): AllocatableLoadMethod | undefined =>
  code ? toDatabaseCode(code, allocatableLoadMethods) : undefined;
